function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnboardingCardImage = function SvgOnboardingCardImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 91,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3h109v21H3V3zM0 24V3a3 3 0 013-3h109a3 3 0 013 3v85a3 3 0 01-3 3H3a3 3 0 01-3-3V24zm112 3H3v61h109V27z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 38.5,
    width: 31,
    height: 10,
    rx: 4.5,
    fill: props.fill,
    stroke: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    d: "M11.687 10.14h6v6h-6zM97.84 10.14h6v6h-6z"
  }));
};
export default SvgOnboardingCardImage;